import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { AppState } from '../../common/store/store';

export const useInsightDrawer = () => {
    const [searchParams] = useSearchParams();
    const insightRoute = useSelector((state: AppState) => state.device.insight);

    const getDefaultWidth = () => Math.min(window.innerWidth * 0.33, 800);
    const drawerWidth = (() => {
        const saved = localStorage.getItem('insightDrawerWidth');
        return saved ? parseInt(saved) : getDefaultWidth();
    })();

    return {
        isOpen: !!insightRoute,
        drawerWidth
    };
};
